export default __webpack_public_path__ + "static/media/Oculus-Rift-profile_grande.11f57019.png";